/**
 * Gemeinsamer Zustand fuer den AgoraHub-Bearbeitungsmodus (Plan W4, 19.10.2026).
 *
 * Bewusst ohne Abhaengigkeiten, damit `publicContent.js` (Bilder) und `editTexts.js` (Texte, Adapter) ihn ohne
 * Kreis-Import teilen. Besucher ohne Bearbeitung sehen hier nur die Startwerte; erst der Adapter (geladen vom
 * Bearbeitungs-Skript) schreibt Entwurfs-Werte hinein.
 *
 *   editing        Bearbeitungsmodus aktiv (pause/resume): Slideshows stehen, aufklappbare Texte sind offen
 *   slots          Entwurfs-Bilder je Platz (setSlot), ueberlagern die veroeffentlichten Bilder
 *   aboutData      veroeffentlichte Ueber-uns-Texte aus der Public API, flach je Sprache ({de: {pfad: wert}})
 *   aboutLists     Reihenfolge der Listen-Eintraege je Sprache ({de: {vision_cards: [position, ...]}})
 *   aboutRaw       veroeffentlichte Ueber-uns-Inhalte je Sprache, unveraendert (nur fuer Links, z. B. RAMI-Website)
 *   aboutOverrides Entwurfs-Werte aus dem Bearbeitungsmodus ({pfad: {de, en}}; null = eingebauter Text)
 */
import { useSyncExternalStore } from 'react';

const INITIAL = Object.freeze({
  editing: false,
  slots: Object.freeze({}),
  aboutData: null,
  aboutLists: Object.freeze({}),
  aboutRaw: Object.freeze({}),
  aboutOverrides: Object.freeze({}),
});

let state = INITIAL;
const listeners = new Set();

export function getEditState() {
  return state;
}

/** `patch(state)` liefert die geaenderten Felder; alle Abonnenten werden benachrichtigt. */
export function updateEditState(patch) {
  const changes = typeof patch === 'function' ? patch(state) : patch;
  if (!changes) return;
  state = { ...state, ...changes };
  listeners.forEach(listener => listener());
}

export function subscribeEdit(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** React-Hook: Auswahl muss eine stabile Referenz liefern (Feld des Zustands, kein neues Objekt). */
export function useEditState(selector) {
  return useSyncExternalStore(subscribeEdit, () => selector(state), () => selector(INITIAL));
}

/** Nur fuer Tests: Zustand zuruecksetzen. */
export function resetEditState() {
  state = INITIAL;
  listeners.forEach(listener => listener());
}
